<template>
  <div class="confirm-layout">
    <div class="alert alert-success">
      此藥物總存量: {{ selectedDrugTotalAmount }} 
    </div>
    <Action 
      v-if="currentProgress === 'confirmAmount'"
      v-on:confirmAmountFinish="confirmAmountFinish"
      :defaultNum="currentDrugInDevice.stock"
      :autoCaculateAmount="false"
      :compType="'Confirm'"
      :valueMoreThanZero="false"
      :defaultPackCount="currentDrugInDevice.pack_count"
      :deviceId="currentDrugInDevice.device.id"
      :checkNum="currentDrugInDevice.max_stock" >
      <h5>確認藥盒內數量</h5>
    </Action>
    <Action
      v-if="currentProgress === 'action'"
      :defaultNum="currentDrugInDevice.stock"
      :deviceId="currentDrugInDevice.device.id"
      :defaultPackCount="currentDrugInDevice.pack_count"
      :valueMoreThanZero="false"
      :inputReadOnly="true"
      v-on:setActionData="getActionData">
      <h5>藥物移除數量</h5>
    </Action>
    <NumberSet 
      v-if="currentProgress === 'setMinStock'"
      v-on:setNum="getMinStorage"
      :defaultAmount="minStorage"
      :canBeZero="true"
      :inputLabel="'更新安全存量'"
    />

    <Loader v-if="currentProgress === 'finish'"/>
  </div>
</template>


<script>
import moment from 'moment';
import Action from '../flowComp/Action';
import Loader from '../common/Loader';
import NumberSet from '../flowComp/NumberSet';
import ConfirmFlowBase from '../ComponentBase/ConfirmFlowBase';

export default {
  name: 'ConfirmFlow',
  extends: ConfirmFlowBase,
  props: [],
  data() {
    return {
      storageAmount: 0,
      totalStorageInSystemId: null,
      minStorage: null,
      confirmAmount: 0,
      emitTimes: 0,
      confirmPackCount: 0,
    };
  },
  components: {
    Action,
    Loader,
    NumberSet,
  },
  mounted() {
    this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
  },
  beforeUpdate() {
    if (this.currentProgress === 'action') {
      this.confirmAmount = this.currentDrugInDevice.stock;
      this.confirmPackCount = this.currentDrugInDevice.pack_count;
    }
  },
  methods: {
    getActionData() {
      this.emitTimes += 1;
      if (this.emitTimes === 1) {
        this.emitData();
      }
    },
    getMinStorage(val) {
      this.instance.patch(`/api/total-storage-in-system/${this.totalStorageInSystemId}/`, {
        min_stock: val,
      })
      .then((res) => {
        this.nextProgress();
        this.$emit('confirmationFinish');
        this.resetProgress();
        this.emitTimes = 0; // reset
      })
      .catch((err) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: `安全存量不可大於總最大庫存量: ${err.response.data.max_stock}`,
          keepOnTop: true,
        });
      });
    },
    emitData() {
      const medId = this.currentDrugInDevice.medication.id;
      this.nextProgress();
      this.instance.delete(`/api/drug-storage/${this.currentDrugInDevice.id}/`, {
        data: {
          type: 'OUTDATE',
        },
      })
      .then(() => {
        // check whether other durg storage with same medication exists.
        this.instance.get('/api/drug-storage/', {
          params: {
            medication: medId,
            exclude_return_device: true,
            device__net__system: this.$store.state.device.systemId,
          },
        })
        .then((res) => {
          this.$store.dispatch('getTotalDrugAmountInstanly', medId);
          const filteredList = [];
          res.data.results.forEach((item) => {
            const theExpiredDate = moment(item.expired_date);
            const todayDate = moment();
            const remainExpiredDays = theExpiredDate.diff(todayDate, 'days');
            if (remainExpiredDays >= 0) {
              filteredList.push(item);
            }
          });
          if (filteredList.length > 0) {
            this.nextProgress(); // set for min_stock
            this.instance.get(`/api/total-storage-in-system/?medication=${medId}`)
            .then((res) => {
              this.totalStorageInSystemId = res.data.results[0].id;
              this.minStorage = parseInt(res.data.results[0].min_stock, 10);
              console.log(this.minStorage);
            });
          } else {
            this.$emit('confirmationFinish');
            this.resetProgress();
            this.emitTimes = 0; // reset
          }
        });
      });
    },
    async confirmAmountFinish(payload) {
      await this.$store.dispatch('updateCurrentDrugInDevice', this.currentDrugInDevice.id);
      this.confirmAmount = payload.totalSum;
      this.confirmPackCount = payload.packCount;
      this.nextProgress();
      setTimeout(() => {
        this.nextProgress();
      }, 200);
    },
  },
  created() {
    if (this.currentProgress === 'wait') this.nextProgress();
  },
  computed: {
  },
};
</script>



// WEBPACK FOOTER //
// ConfirmFlow.vue?16a1e1c3